import React from 'react';
import QuestionEntity, { QuestionEntityData } from './QuestionEntity';
import { RatingGrid, RatingGridData } from '../answers/RatingGrid';

export type RatingGridQuestionData = Omit<QuestionEntityData, 'answerElement'> &
  RatingGridData;

export const RatingGridQuestion: React.FC<RatingGridQuestionData> = props => {
  return (
    <QuestionEntity {...props} answerElement={<RatingGrid {...props} />} />
  );
};
